module.exports = __webpack_public_path__ + "static/Gotham-Medium-70c57be1e681533de271f41046d220b4.woff";